export default [
    {
        path: '/html',
        component : () => import('@/views/html/main'),
        children:[

            {
                path:'dashboard',
                component : () => import('@/views/html/dashboard')
            },
            {
                path:'electricity',
                component : () => import('@/views/html/electricity/electricity.bill')
            }
        ]
    },
];